import { render } from "./DashboardContractListCmp.vue?vue&type=template&id=6bbb15fd"
import script from "./DashboardContractListCmp.vue?vue&type=script&lang=js"
export * from "./DashboardContractListCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__